module.exports = __webpack_public_path__ + "img/图片9.d497be20.png";